import { Store } from "@betomorrow/micro-stores"
import { Box, BoxDraft, ItemBox } from "@modules/box/boxTypes"
import { BoxApiGateway } from "@modules/box/services/boxApi.gateway"
import { convertBoxDraftToDto, convertBoxFromDto, convertItemBoxFromDto } from "@modules/box/services/boxDto"
import { CurrentSpaceManagerType } from "@modules/core/services/currentSpaceManager.type"
import { Service } from "@modules/core/services/serviceType"
import { QueryClient } from "@tanstack/react-query"
import { observable } from "micro-observables"

export class BoxService implements Service {
  private _boxs = observable<ItemBox[]>([])
  readonly boxs = this._boxs.readOnly()
  private _isLoadingBoxs = observable<boolean>(true)
  readonly isLoadingBoxs = this._isLoadingBoxs.readOnly()
  boxStore = new Store<Box>((id) => this.api.getBox(id).then((dto) => convertBoxFromDto(dto)))

  constructor(
    private api: BoxApiGateway,
    private currentSpaceManager: CurrentSpaceManagerType,
    private queryClient: QueryClient,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async init() {}

  async onLoggedOut(): Promise<void> {
    this._boxs.set([])
    this.boxStore.clear()
    this.queryClient.clear()
  }

  async createBox(box: BoxDraft) {
    const result = await this.api.createBox(convertBoxDraftToDto(box))
    this.boxStore.save(convertBoxFromDto(result))
    this.updateBoxs()
    return result
  }

  async updateBox(id: string, box: BoxDraft) {
    const result = await this.api.updateBox(id, convertBoxDraftToDto(box))
    this.updateBoxs()
    this.boxStore.save(convertBoxFromDto(result))
  }

  async deleteBox(id: string) {
    await this.api.deleteBox(id)
    this.boxStore.remove(id)
    const currentBoxs = this._boxs.get()
    this._boxs.set(currentBoxs.filter((it) => it.id !== id) ?? [])

    if (this.currentSpaceManager.boxId === id) {
      this.currentSpaceManager.set(null)
    }
  }

  async updateBoxs() {
    this._isLoadingBoxs.set(true)
    const result = await this.api.getBoxs()
    this._boxs.set(result.map((dto) => convertItemBoxFromDto(dto)))
    this._isLoadingBoxs.set(false)
  }
}
